export default __webpack_public_path__ + "static/media/filterDownArrowIcon.c39520a1.svg";